{
	"cardHeader": "Access your declarations",
	"supplierTitle": "You are the supplier of an evoZero declaration?",
	"supplierDescription": "Manage the declarations for your evoZero materials.",
	"loginButton": "Login"
}
